module.exports = __webpack_public_path__ + "static/media/novo.b2eacb32.PNG";